import { useEffect, useRef } from 'react';
import useActiveState from "../lib/useActiveState";
import URI from "urijs";

const useWindowMessage = (handlers = {}) => {
  const [agent] = useActiveState('agent');
  
  // 使用 useRef 保存最新的回调函数，避免 useEffect 依赖变化导致频繁解绑绑定
  const handlersRef = useRef(handlers);
  
  // 每次渲染都更新 ref.current，保证拿到最新的函数引用
  useEffect(() => {
    handlersRef.current = handlers;
  });

  useEffect(() => {
    const handleMessage = (event) => {
      const result = event.data;      
      if (result?.type) {
        if (result.type === "nisptb") {
          //跳转平台币
          let url = URI("https://sys.99maiyou.com/home/MixPay/ptb")
            .addQuery("username", localStorage.getItem("username"))
            .addQuery("token", localStorage.getItem("token"))
            .addQuery("location_url", window.location.origin)
            .addQuery("agent", agent)
            .addQuery("from", "react")
            .toString();

          window.location.href =
            "#/iframe?url=" +
            encodeURIComponent(url) +
            "&title=充值&sinfo=nisptb";
        } else if(result.type === 'close_pay') {
          //重新加载 - 调用回调
          if (handlersRef.current.onClosePay) {
            handlersRef.current.onClosePay();
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);

    // 清理函数
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [agent]); // agent 变化时重新绑定
};

export default useWindowMessage;
